import React, {
	FunctionComponent,
	ChangeEvent,
	useState,
	useEffect,
} from "react"
import { Radio } from "@walmart-web/livingdesign-components"
import "./index.css"
import { useIntl } from "react-intl"

const RadioButtonPenetrationSelector: FunctionComponent<MetricRadioButtonSelectorProperties> = ({
	selectedOption,
	onSelectedPenetrationChanged,
	penetrations,
	type = "",
}) => {
	const [selectedPenetration, setSelectedPenetration] = useState(selectedOption)
	useEffect(() => setSelectedPenetration(selectedOption), [selectedOption])
	const intl = useIntl()

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const id = event.target.id.split("_")[0]
		setSelectedPenetration(id)
		onSelectedPenetrationChanged(id)
	}

	return (
		<div className="radio-button-penetration-selector">
			{penetrations.map((penetration) => {
				return (
					!penetration.disabled && (
						<label
							key={penetration.value}
							className="metric-checkmark-container"
						>
							<div className="option-label"></div>
							<Radio
								data-testid={"penetration-radiobutton"}
								id={penetration.value + "_" + type}
								checked={selectedPenetration === penetration.value}
								label={intl.formatMessage({
									id: `phronesis.transactional.application.commercial.benchmark.penetration.select.${penetration.value}`,
								})}
								name="myRadioGroup"
								onChange={handleChange}
							/>
						</label>
					)
				)
			})}
			<div style={{ clear: "both" }} />
		</div>
	)
}

export interface DataPenetrations {
	disabled?: boolean
	value: string
}

interface MetricRadioButtonSelectorProperties {
	onSelectedPenetrationChanged: (value: string) => void
	selectedOption?: string
	penetrations: Array<DataPenetrations>
	type?: string
}

export default RadioButtonPenetrationSelector
